import React, { useState, useCallback } from 'react';
import { FormGroup } from '~/components/form';
import { useForm, asyncState, useRouter, } from '~/hooks';
import { Portal } from '~/components';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import Modal from '~/components/Modal';
import {  MdClose } from 'react-icons/md';
import { stringUtils } from '~/util';
import { searchSytemApi } from '~/api';

const defaultState = {
    systemSearchName: '',
    id: 0,
    isEditMode: false,
};

const validateAddSearchSystem = (data) => {

    const requiredFields = [
        'systemSearchName',
    ];
    
    return requiredFields.reduce((acc, field) => {
        const value = data[field];
        if (!stringUtils.hasValue(value)) {
            acc[field] = 'This is a required field';
        } 
        return acc;
    }, {});

};

const onSubmit = async ({ values, onInvalidForm, resetFormErrors, onFail}) => {
    resetFormErrors();
    const errors = validateAddSearchSystem(values);

    if (Object.keys(errors).length > 0) {
        return onInvalidForm(errors);
    }

    const {
        systemSearchName,
        isEditMode,
        id
    } = values;

    try {
        if(isEditMode) {
            await searchSytemApi.updateSearchSystem(id,systemSearchName);
        } else {
            await searchSytemApi.addSearchSystem(systemSearchName);
        }
        
        return true;
    } catch (err) {
        console.error(err);
        return onFail(err.message);
    }

};

const loadData = async (values, props) => {
    let isEditMode = props.editSystemSearch;
    const system_search_name = isEditMode ? props.systemSearchData.name : '';
    const id = isEditMode ? props.systemSearchData.id : 0;

    return {
        ...values,
        systemSearchName: system_search_name,
        id: id,
        isEditMode: isEditMode
    };
};

const AddSystem = (props) => {
    const [status, setStatus] = useState(asyncState.IDLE);
    const { history } = useRouter();

    const onLoad = useCallback((values, props) => {
        return loadData(values, props);
    }, [props.filtersOpen]);


    const {
        state,
        fieldActions,
        formActions
    } = useForm({
        initialState: defaultState,
        props,
        onSubmit,
        onLoad,
        debug: true
    });


    return(
        <>
            {(status == asyncState.IDLE || status == asyncState.ERROR) &&
            <Modal isModalOpen={props.filtersOpen} preventScroll className='rounded-md bg-white'>
                <section className='w-full h-full flex flex-col items-stretch justify-start'>
                    <>
                        <header className="border-b-2 text-md flex items-center justify-between py-2 px-4">
                            {props.editSystemSearch ? 
                                <p className="font-semibold">Edit System Search</p>
                                :
                                <p className="font-semibold">Add System Search</p>
                            }
                            
                            <button 
                                className="py-2 rounded-full"
                                onClick={props.filtersClose}
                            >
                                <MdClose size="1em" />
                            </button>
                            {status == asyncState.PENDING && (
                                <Portal id="loading-modal">
                                    <div className="flex items-center justify-center h-screen w-screen bg-gray-400 opacity-70 z-50 fixed top-0 left-0 translate-y-1/2 -translate-x-1/2">
                                        <AiOutlineLoading3Quarters className="animate-spin text-blue-30 font-bold" size="4rem" />
                                    </div>
                                </Portal>
                            )}
                        </header>
                
                        {state.isErrored && (
                            <span className="bg-red-200 text-center text-red-500 text-lg block -mt-6 -mx-6 rounded-t-md px-6 py-2">
                                There was an issue adding the system.
                            </span>
                        )}
                        <div className='flex items-center justify-center flex-1 p-6'>
                            <div className='grid grid-cols-11 gap-y-4'>
                                <FormGroup
                                    inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                                    groupClassName='col-span-11'
                                    label='System Search Name'
                                    value={state.values.systemSearchName}
                                    error={state.errors.systemSearchName}
                                    path='systemSearchName'
                                    {...fieldActions}
                                />
                                <div className='col-span-11 flex items-center justify-end text-xs'>
                                    <button 
                                        className='py-2 px-4 rounded-full border mr-2 focus:outline-none'
                                        onClick={()=>{
                                            formActions.reset();
                                            props.filtersClose();
                                        }}
                                    >
                                        CANCEL
                                    </button>
                                    <button 
                                        className='py-2 px-4 rounded-full bg-blue-50 text-white focus:outline-none'
                                        disabled={Object.keys(state.errors).length}
                                        onClick={() => {
                                            if (Object.keys(state.errors).length < 1) {
                                                setStatus(asyncState.PENDING);
    
                                                formActions.submit((result) => {
                                                    if (result) {
                                                        setStatus(asyncState.SUCCESS);
                                                        history.go(0);
                                                    } else {
                                                        setStatus(asyncState.ERROR);
                                                    }
                                                });
                                            }
                                        }}
                                    >
                                        {props.editSystemSearch ? 'UPDATE' : 'ADD'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </>
                </section>
            </Modal>
            }
        </>
    );
};

export default AddSystem;